require('babel-polyfill');
require('source-map-support').install();
module.exports = require('./server');